import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import api from "@/lib/api";
import { Mail, MapPin, Send } from "lucide-react";
import { SEO } from "@/components/SEO";

export default function ContactPage() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/contact", form);
      toast.success("Message envoyé avec succès !");
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch { toast.error("Erreur lors de l'envoi du message"); }
    setLoading(false);
  };

  return (
    <>
      <SEO title="Contact" description="Contactez l'équipe éditoriale d'OFALycée." url="/contact" />
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24" data-testid="contact-page">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24">
          <div>
            <span className="text-sm font-mono tracking-widest uppercase text-primary mb-4 block">Contact</span>
            <h1 className="font-heading text-4xl md:text-5xl mb-6">Parlons ensemble</h1>
            <p className="text-muted-foreground text-lg leading-relaxed mb-12">Une question sur nos contenus ? Une idée de collaboration ? N'hésitez pas à nous écrire.</p>
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <Mail className="h-5 w-5 text-primary mt-0.5" />
                <div><h3 className="font-medium mb-1">Email</h3><p className="text-muted-foreground text-sm">ovincent@ofalycee.org</p></div>
              </div>
              <div className="flex items-start gap-4">
                <MapPin className="h-5 w-5 text-primary mt-0.5" />
                <div><h3 className="font-medium mb-1">Adresse</h3><p className="text-muted-foreground text-sm">OFA Lycée &mdash; Winchester, USA</p></div>
              </div>
            </div>
          </div>
          <form onSubmit={handleSubmit} className="space-y-6" data-testid="contact-form">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div><Label htmlFor="name">Nom</Label><Input id="name" value={form.name} onChange={(e) => setForm({...form, name: e.target.value})} placeholder="Votre nom" className="border-b border-input bg-transparent px-0 rounded-none focus-visible:ring-0 mt-2" required data-testid="contact-name" /></div>
              <div><Label htmlFor="email">Email</Label><Input id="email" type="email" value={form.email} onChange={(e) => setForm({...form, email: e.target.value})} placeholder="votre@email.com" className="border-b border-input bg-transparent px-0 rounded-none focus-visible:ring-0 mt-2" required data-testid="contact-email" /></div>
            </div>
            <div><Label htmlFor="subject">Sujet</Label><Input id="subject" value={form.subject} onChange={(e) => setForm({...form, subject: e.target.value})} placeholder="Sujet de votre message" className="border-b border-input bg-transparent px-0 rounded-none focus-visible:ring-0 mt-2" data-testid="contact-subject" /></div>
            <div><Label htmlFor="message">Message</Label><Textarea id="message" value={form.message} onChange={(e) => setForm({...form, message: e.target.value})} placeholder="Votre message..." className="min-h-[150px] border border-input bg-transparent rounded-none focus-visible:ring-0 mt-2" required data-testid="contact-message" /></div>
            <Button type="submit" disabled={loading} className="rounded-none px-8" data-testid="contact-submit"><Send className="h-4 w-4 mr-2" /> Envoyer</Button>
          </form>
        </div>
      </div>
    </>
  );
}
